import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Cards from '../../../../Components/Cards/Cards';
import { getPercentageSafe } from '../../../../Utils/MathUtils';
import Stats from '../../../../Components/Stats/Stats';
class SessionDetailsStats extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    isBig: PropTypes.bool.isRequired,
    attendees: PropTypes.number,
    avgInterestRating: PropTypes.number,
    totalAverageAttentiveness: PropTypes.number,
    registrants: PropTypes.number
  };
  render() {
    const { attendees = 0, avgInterestRating = 0, totalAverageAttentiveness = 0, registrants = 0, isBig } = this.props;
    const { t } = this.context;
    const cardArray = [
      {
        uniqueId: 'session_details_stats_card_attendees',
        subText: t('sessionDetails.attendees'),
        title: attendees,
        moreInfoTooltip: t('header.cardTypes.sessionDetailsAttendeesTooltip')
      },
      {
        uniqueId: 'session_details_stats_card_avgInterestRating',
        subText: t('sessionDetails.averageInterestRating'),
        title: avgInterestRating,
        moreInfoTooltip: t('header.cardTypes.averageInterestRatingTooltip')
      },
      {
        uniqueId: 'session_details_stats_card_totalAverageAttentiveness',
        subText: t('sessionDetails.totalAverageAttentiveness'),
        title: totalAverageAttentiveness,
        moreInfoTooltip: t('header.cardTypes.totalAverageAttentivenessTooltip')
      },
      {
        uniqueId: 'session_details_stats_card_attendanceRate',
        subText: t('sessionDetails.attendanceRate'),
        title: `${getPercentageSafe(attendees, registrants)}%`,
        moreInfoTooltip: t('header.cardTypes.sessionDetailsAttendanceRateTooltip')
      }
    ];
    return isBig ? <Cards contents={cardArray} /> : <Stats contents={cardArray} />;
  }
}
export default SessionDetailsStats;



// WEBPACK FOOTER //
// ./src/GoToWebinar/Sessions/SessionDetails/Stats/SessionDetailsStats.js